import React from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomTabs from "../../../../components/custom-tabs/CustomTabs";
import { COMPANY_DETAIL_PROFILE_TABS } from "../constants";

import BasicInfo from "./profile/BasicInfo";
import Products from "./profile/Products";
import Awards from "./profile/Awards";
import Certifications from "./profile/Certifications";
import Services from "./profile/Services";
import Portfolios from "./profile/Portfolios";
import GroupBuyOffers from "./profile/GroupBuyOffers";

const Profile = () => {
  const [searchParams] = useSearchParams();
  const { companyDetail } = useSelector((state) => state.company);
  const activeProfileTab = searchParams.get("profile-tabs") || "basic-info";

  const renderProfileTabContent = (activeTab) => {
    switch (activeTab) {
      case "basic-info":
        return <BasicInfo />;
      case "products":
        return <Products />;
      case "awards":
        return <Awards />;
      case "certifications":
        return <Certifications />;
      case "services":
        return <Services />;
      case "portfolios":
        return <Portfolios />;
      case "group-buy-offers":
        return <GroupBuyOffers />;
      default:
        return <BasicInfo />;
    }
  };

  return (
    <div className="profile-tab grid gap-3">
      {/* Sidebar Sub-tabs */}
      <div className="bg-white rounded-3 g-col-2 p-3 shadow-md h-fit-content">
        <h5 className="mb-2 fw-bold" style={{ fontSize: "16px" }}>Profile Sections</h5>
        <CustomTabs
          accessor="profile-tabs"
          className="flex-column gap-2"
          linkClassName="w-100 text-start"
          items={COMPANY_DETAIL_PROFILE_TABS}
          defaultTab="basic-info"
          variant="pills"
        />
      </div>

      {/* Main Tab Content */}
      <div className="bg-white rounded-3 g-col-6 p-4 shadow-md h-fit-content">
        {renderProfileTabContent(activeProfileTab)}
      </div>

      {/* Verification Summary Sidebar */}
      <div className="g-col-4">
        <div className="bg-white rounded-3 mb-3 p-3 shadow-md user-details-page">
          <div className="overview-tab">
            <h6 className="fw-bold mb-3" style={{ fontSize: "15px" }}>Verification Summary</h6>
            <div className="verification-rows-container flex-grow-1">
              <div className="verification-row py-2">
                <span className="verification-label small">Email Verification</span>
                <div className={`verification-value-wrapper ${companyDetail?.creator?.is_email_verified ? "text-success" : "text-danger"}`}>
                  <span className="fw-semibold me-1" style={{ fontSize: "12px" }}>
                    {companyDetail?.creator?.is_email_verified ? "Verified" : "Not Verified"}
                  </span>
                  {companyDetail?.creator?.is_email_verified ? (
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-success">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="16 9 11 14 8 11" />
                    </svg>
                  ) : (
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-danger">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="15" y1="9" x2="9" y2="15" />
                      <line x1="9" y1="9" x2="15" y2="15" />
                    </svg>
                  )}
                </div>
              </div>
              <div className="verification-row py-2">
                <span className="verification-label small">Mobile Verification</span>
                <div className={`verification-value-wrapper ${companyDetail?.creator?.is_mobile_verified ? "text-success" : "text-danger"}`}>
                  <span className="fw-semibold me-1" style={{ fontSize: "12px" }}>
                    {companyDetail?.creator?.is_mobile_verified ? "Verified" : "Not Verified"}
                  </span>
                  {companyDetail?.creator?.is_mobile_verified ? (
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-success">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="16 9 11 14 8 11" />
                    </svg>
                  ) : (
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-danger">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="15" y1="9" x2="9" y2="15" />
                      <line x1="9" y1="9" x2="15" y2="15" />
                    </svg>
                  )}
                </div>
              </div>
              <div className="verification-row py-2">
                <span className="verification-label small">Verification Status</span>
                <div className={`verification-value-wrapper ${companyDetail?.is_verified ? "text-success" : "text-danger"}`}>
                  <span className="fw-semibold me-1" style={{ fontSize: "12px" }}>
                    {companyDetail?.is_verified ? "Verified" : "Not Verified"}
                  </span>
                  {companyDetail?.is_verified ? (
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-success">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="16 9 11 14 8 11" />
                    </svg>
                  ) : (
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-danger">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="15" y1="9" x2="9" y2="15" />
                      <line x1="9" y1="9" x2="15" y2="15" />
                    </svg>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
